import { DatePicker, Select, Skeleton } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import { disableFutureDates } from "../../services/util";
import { ColumnChart, FilterBar } from "./chartUtils";
dayjs.extend(customParseFormat);

const { Option } = Select;

function TicketByGroup({ projects }) {
    const [groups, setGroups] = useState([]);
    const [users, setUsers] = useState([]);
    const [columnChartData, setColumnChartData] = useState([]);
    const [defaultYear, setDefaultYear] = useState(dayjs());
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [userGroupFormData, setUserGroupFormData] = useState({
        staff_id,
        group_id: "",
    });
    const [formData, setFormData] = useState({
        staff_id,
        range_year: defaultYear.get("year"),
        project_id: "-1",
        group_id: "",
        user_id: "",
    });

    const {
        status: jiraGroupStatus,
        data: groupsRes,
        refetch: fetchGroups,
    } = useQuery(
        "groups",
        async () => await HTTP("/analytics/getJiraGroups", { staff_id }),
        { enabled: false },
    );

    const {
        status: jiraUsersStatus,
        data: usersRes,
        refetch: fetchUsers,
    } = useQuery(
        "jira-users",
        async () =>
            await HTTP("/analytics/getJiraUsersByGroup", {
                ...userGroupFormData,
            }),
        { enabled: false },
    );

    const {
        status: columnChartStatus,
        data: columnChartDataRes,
        refetch,
    } = useQuery(
        "TicketByGroup",
        async () =>
            await HTTP("/analytics/getJiraGroupBarChartData", { ...formData }),
        { enabled: false },
    );

    useEffect(() => {
        fetchGroups();
        fetchUsers();
        refetch();
    }, []);
    useEffect(() => {
        refetch();
    }, [formData]);
    useEffect(() => {
        refetch();
        fetchUsers();
    }, [userGroupFormData]);

    useEffect(() => {
        if (jiraGroupStatus === "success") setGroups(groupsRes.data);
    }, [jiraGroupStatus, groupsRes]);

    useEffect(() => {
        if (jiraUsersStatus === "success") setUsers(usersRes.data);
    }, [jiraUsersStatus, usersRes]);

    useEffect(() => {
        if (columnChartStatus === "success")
            setColumnChartData(columnChartDataRes.data);
    }, [columnChartStatus, columnChartDataRes]);

    function handleYearChange(_, dateString) {
        setDefaultYear(dateString === "" ? dayjs() : dayjs(dateString));
        setFormData((prev) => ({
            ...prev,
            range_year: dateString || dayjs().get("year"),
        }));
    }

    function handleProjectSelectionChange(e) {
        setFormData((prev) => ({
            ...prev,
            project_id: e ? e.split("#")[0] : -1,
        }));
    }

    function handleGroupSelectionChange(e) {
        const group_id = e ? e.split("#")[0] : "";
        setUserGroupFormData((prev) => ({ ...prev, group_id }));
        setFormData((prev) => ({ ...prev, group_id }));
    }

    function handleUserSelectionChange(e) {
        const user_id = e ? e.split("#")[0] : "";
        setUserGroupFormData((prev) => ({ ...prev, user_id }));
        setFormData((prev) => ({ ...prev, user_id }));
    }

    const isReady =
        columnChartStatus !== "loading" && columnChartStatus !== "idle";

    return (
        <>
            <FilterBar>
                <DatePicker
                    defaultValue={defaultYear}
                    onChange={handleYearChange}
                    picker="year"
                    allowClear={false}
                    disabledDate={disableFutureDates}
                    style={{ width: 120 }}
                />
                <Select
                    allowClear
                    showSearch
                    placeholder="Project"
                    onChange={handleProjectSelectionChange}
                    style={{ flex: 1, minWidth: 140 }}
                >
                    {projects.map((e) => (
                        <Option key={`${e.project_id}#${e.project_name}`}>
                            {e.project_name}
                        </Option>
                    ))}
                </Select>
                <Select
                    allowClear
                    showSearch
                    placeholder="Group"
                    onChange={handleGroupSelectionChange}
                    style={{ flex: 1, minWidth: 140 }}
                >
                    {groups.map((e) => (
                        <Option key={`${e.group_id}#${e.group_name}`}>
                            {e.group_name}
                        </Option>
                    ))}
                </Select>
                <Select
                    allowClear
                    showSearch
                    placeholder="User"
                    onChange={handleUserSelectionChange}
                    style={{ flex: 1, minWidth: 140 }}
                >
                    {users.map((e) => (
                        <Option key={`${e.user_id}#${e.user_name}`}>
                            {e.user_name}
                        </Option>
                    ))}
                </Select>
            </FilterBar>
            {isReady && columnChartData.length > 0 ? (
                <ColumnChart rawData={columnChartData} height={420} />
            ) : (
                <Skeleton
                    active
                    title={false}
                    paragraph={{ rows: 10, width: "100%" }}
                />
            )}
        </>
    );
}

export default TicketByGroup;
